import { motion } from "framer-motion";
import useStyles from "./styles";
import { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../component/Navbar/NavBar";
import Footer from "../../Footer/Footer";

const Terms = () => {
  const classes = useStyles();
  const FooterRef = useRef(null);
  const FAQRef = useRef(null);
  const HowitworksRef = useRef(null);
  const AboutRef = useRef(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Navbar
        FooterRef={FooterRef}
        HowitworksRef={HowitworksRef}
        AboutRef={AboutRef}
        FAQRef={FAQRef}
      />
      <div className={classes.root}>
        <div className={classes.margincont}>
          <div className={classes.container}>
            <motion.div
              className={classes.content}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h1 className={classes.title}>TERMS OF SERVICES</h1>

              <div className={classes.section}>
                <h2 className={classes.heading}>WHAT WE DO</h2>
                <p className={classes.text}>
                  SlotFinance helps trusted friends (groups) save together (ajo) with the use of automated cycles, seamless & verified payouts and transparent tracking.
                </p>
                <p className={classes.text}>
                  We are not a BANK; Payments are processed by Licensed Third party providers such as Monnify and co.
                </p>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>WHO CAN ACCESS SLOTFINANCE</h2>
                <ul className={classes.list}>
                  <li>18+ with a valid bank account</li>
                  <li>To register; it requires phone verification and referral code</li>
                  <li>Updated finance profile ( Employment, salary/income range, saving habits) to access app's full features</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>SLOTS, GROUPS & SIGNATORIES</h2>
                <ul className={classes.list}>
                  <li>Each group dictates its cycle i.e amount contributed, duration and order of payout</li>
                  <li>Slot's percentage ranging from 50%, 100%, 150% reflects payout tier.</li>
                  <li>For each group, there are two signatories to verify payments before payouts</li>
                  <li>Terms are not adjustable once a cycle commences</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>CONTRIBUTIONS AND PAYOUTS</h2>
                <ul className={classes.list}>
                  <li>Payment is done on or before due date</li>
                  <li>Late payment attracts a fine (to be stated)</li>
                  <li>Funds get paid on your Slotday once approved by signatories</li>
                  <li>There's an option to either request for a slot advance (early payout) or slot freeze (temporary hold)</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>PAYMENT & FEES</h2>
                <ul className={classes.list}>
                  <li>Securedly processed via Paystack, Fincra, monnify, paga, or opay</li>
                  <li>Transaction fee may apply</li>
                  <li>Slotfinance isn't liable for any third party error or incorrect bank details</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>SECURITY</h2>
                <ul className={classes.list}>
                  <li>Endeavor to keep your login details private</li>
                  <li>We'd never ask for password, pin or OTP outside the app</li>
                  <li>Suspicious activity or fraud leads to outright suspension</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>PRIVACY</h2>
                <ul className={classes.list}>
                  <li>Your data is well encrypted and protected</li>
                  <li>Limited info such as name, slot level, role is visible to group members</li>
                  <li>See full details in <Link to="/privacy" className={classes.link}>Privacy Policy</Link></li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>ACCOUNT SUSPENSION</h2>
                <ul className={classes.list}>
                  <li>You're at liberty to delete your account once a cycle is completed</li>
                  <li>We may suspend or permanently close an account for policy violations, repeated missed contributions or Fraud</li>
                </ul>
              </div>

              <div className={classes.section}>
                <h2 className={classes.heading}>DISPUTES</h2>
                <p className={classes.text}>
                  Internally resolve group issues before escalation
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      <div ref={FooterRef}>
        <Footer />
      </div>
    </>
  );
};

export default Terms;
